(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-lens"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeArtLens = (root) => {
      if (root.dataset.artLensBound === 'true') return;
      const range = root.querySelector('[data-art-lens-range]');
      const artwork = root.querySelector('.dap-art-lens-image--artwork');
      const divider = root.querySelector('[data-art-lens-divider]');
      const output = root.querySelector('[data-art-lens-output]');
      if (!range || !artwork || !divider) return;

      root.dataset.artLensBound = 'true';
      const update = () => {
        const value = Math.min(100, Math.max(0, Number(range.value) || 0));
        const roomValue = value;
        const artworkValue = 100 - value;
        artwork.style.clipPath = `inset(0 ${roomValue}% 0 0)`;
        divider.style.left = `${artworkValue}%`;
        range.setAttribute('aria-valuetext', range.dataset.valueTemplate
          .replace('[artwork]', String(artworkValue))
          .replace('[room]', String(roomValue)));
        if (output) output.textContent = `${artworkValue} / ${roomValue}`;
      };

      range.addEventListener('input', update);
      range.addEventListener('keydown', (event) => {
        const decreases = event.key === 'ArrowLeft' || event.key === 'ArrowDown';
        const increases = event.key === 'ArrowRight' || event.key === 'ArrowUp';
        if (!decreases && !increases && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        if (event.key === 'Home') range.value = '0';
        if (event.key === 'End') range.value = '100';
        if (decreases) range.value = String(Math.max(0, Number(range.value) - 1));
        if (increases) range.value = String(Math.min(100, Number(range.value) + 1));
        update();
      });
      update();
    };

    document.querySelectorAll('[data-art-lens-root]').forEach(initializeArtLens);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-art-lens-root]').forEach(initializeArtLens));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-discovery"]) return;
  try {
    
  (() => {
    const compactFilters = window.matchMedia('(max-width: 1100px)');
    const listFacets = ['rooms', 'subjects', 'palette', 'styleMood'];
    const allFacets = [...listFacets, 'livingArt'];

    const parseList = (value) => {
      try {
        const parsed = JSON.parse(value || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    };

    const initDiscovery = (section) => {
      if (!section || section.dataset.dapDiscoveryBound === 'true') return;
      section.dataset.dapDiscoveryBound = 'true';

      const shell = section.querySelector('[data-dap-filter-shell]');
      const form = section.querySelector('[data-dap-discovery-form]');
      const filterDialog = section.querySelector('[data-dap-filter-dialog]');
      const filterTrigger = shell?.querySelector(':scope > summary');
      const grid = section.querySelector('[data-dap-results-grid]');
      let cards = [];
      const inputs = [...section.querySelectorAll('[data-dap-discovery-form] input[type="checkbox"]')];
      const sort = section.querySelector('[data-dap-sort]');
      const resultCount = section.querySelector('[data-dap-results-count]');
      const activeFilters = section.querySelector('[data-dap-active-filters]');
      const chips = section.querySelector('[data-dap-filter-chips]');
      const activeCount = section.querySelector('[data-dap-active-count]');
      const showButton = section.querySelector('[data-dap-filter-show]');
      const loadMore = section.querySelector('[data-dap-load-more]');
      const emptyState = section.querySelector('[data-dap-empty-state]');
      const pageSize = Number(section.dataset.pageSize) || 12;
      let visibleLimit = pageSize;
      let cardData = new Map();
      let inertedBackground = [];

      const filterFocusable = () => [...filterDialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
      )].filter((element) => element.getClientRects().length > 0 && !element.closest('[inert]'));

      const releaseFilterBackground = () => {
        inertedBackground.forEach((element) => element.removeAttribute('inert'));
        inertedBackground = [];
      };

      const isolateFilterBackground = () => {
        releaseFilterBackground();
        let branch = filterDialog;
        while (branch && branch !== document.body) {
          const parent = branch.parentElement;
          if (!parent) break;
          [...parent.children].forEach((sibling) => {
            if (sibling === branch || sibling.matches('script, style, link, template') || sibling.hasAttribute('inert')) return;
            sibling.setAttribute('inert', '');
            inertedBackground.push(sibling);
          });
          branch = parent;
        }
      };

      const deactivateFilterDialog = (returnFocus = false) => {
        filterDialog.removeAttribute('role');
        filterDialog.removeAttribute('aria-modal');
        releaseFilterBackground();
        document.body.classList.remove('dap-filter-open');
        if (returnFocus) requestAnimationFrame(() => filterTrigger?.focus());
      };

      const activateFilterDialog = () => {
        filterDialog.setAttribute('role', 'dialog');
        filterDialog.setAttribute('aria-modal', 'true');
        isolateFilterBackground();
        document.body.classList.add('dap-filter-open');
        requestAnimationFrame(() => {
          const preferredTarget = filterDialog.querySelector('[data-dap-filter-close]') || filterFocusable()[0] || filterDialog;
          preferredTarget.focus();
        });
      };

      const closeFilterDialog = (returnFocus = true) => {
        shell.removeAttribute('open');
        deactivateFilterDialog(returnFocus);
      };

      const registerCards = () => {
        cards = [...section.querySelectorAll('[data-dap-filter-item]')];
        cardData = new Map(cards.map((card) => [card, {
          rooms: parseList(card.dataset.rooms),
          subjects: parseList(card.dataset.subjects),
          palette: parseList(card.dataset.palette),
          styleMood: parseList(card.dataset.styleMood),
          livingArt: card.dataset.livingArt === 'true',
          price: Number(card.dataset.price) || 0,
          published: Number(card.dataset.published) || 0,
          title: card.dataset.title || '',
          curatorRank: Number(card.dataset.curatorRank) || 999
        }]));
      };

      const selectedFor = (facet) => inputs.filter((input) => input.name === facet && input.checked).map((input) => input.value);

      const matchesValue = (data, facet, value) => {
        if (listFacets.includes(facet)) return data[facet].includes(value);
        if (facet === 'livingArt') return data.livingArt;
        return true;
      };

      const matchesCard = (card, ignoredFacet = '') => {
        const data = cardData.get(card);
        return allFacets.every((facet) => {
          if (facet === ignoredFacet) return true;
          const selected = selectedFor(facet);
          return selected.length === 0 || selected.some((value) => matchesValue(data, facet, value));
        });
      };

      const sortedCards = () => [...cards].sort((first, second) => {
        const a = cardData.get(first);
        const b = cardData.get(second);
        if (sort.value === 'newest') return b.published - a.published;
        if (sort.value === 'price-low') return a.price - b.price || a.curatorRank - b.curatorRank;
        if (sort.value === 'price-high') return b.price - a.price || a.curatorRank - b.curatorRank;
        if (sort.value === 'title') return a.title.localeCompare(b.title);
        return a.curatorRank - b.curatorRank;
      });

      const labelFromTemplate = (element, count) => {
        const template = count === 1 ? element.dataset.one : element.dataset.many;
        return (template || '').replace('[count]', String(count));
      };

      const updateOptionCounts = () => {
        inputs.forEach((input) => {
          const count = cards.filter((card) => matchesCard(card, input.name) && matchesValue(cardData.get(card), input.name, input.value)).length;
          const label = input.closest('label');
          const countNode = label?.querySelector('[data-dap-option-count]');
          if (countNode) countNode.textContent = String(count);
          input.disabled = count === 0 && !input.checked;
        });
      };

      const updateChips = () => {
        const selectedInputs = inputs.filter((input) => input.checked);
        const hasFilters = selectedInputs.length > 0;
        activeFilters.hidden = !hasFilters;
        activeCount.hidden = !hasFilters;
        activeCount.textContent = String(selectedInputs.length);
        section.querySelectorAll('[data-dap-clear-all]').forEach((button) => { button.hidden = !hasFilters; });
        chips.replaceChildren(...selectedInputs.map((input) => {
          const button = document.createElement('button');
          const label = input.closest('label')?.querySelector('[data-dap-option-label]')?.textContent?.trim() || input.value;
          button.type = 'button';
          button.dataset.dapRemoveFilter = input.name;
          button.dataset.value = input.value;
          button.setAttribute('aria-label', activeFilters.dataset.removeTemplate.replace('[label]', label));
          button.append(document.createTextNode(`${label} `));
          const close = document.createElement('span');
          close.setAttribute('aria-hidden', 'true');
          close.textContent = '×';
          button.append(close);
          return button;
        }));
      };

      const syncUrl = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('page');
        allFacets.forEach((facet) => url.searchParams.delete(`dap_${facet}`));
        inputs.filter((input) => input.checked).forEach((input) => url.searchParams.append(`dap_${input.name}`, input.value));
        if (sort.value === 'curator') url.searchParams.delete('dap_sort');
        else url.searchParams.set('dap_sort', sort.value);
        history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
      };

      const render = (updateUrl = true) => {
        const ordered = sortedCards();
        ordered.forEach((card) => grid.append(card));
        const matching = ordered.filter((card) => matchesCard(card));
        cards.forEach((card) => { card.hidden = true; });
        matching.slice(0, visibleLimit).forEach((card) => { card.hidden = false; });
        const count = matching.length;
        resultCount.textContent = labelFromTemplate(resultCount, count);
        showButton.textContent = labelFromTemplate(showButton, count);
        emptyState.hidden = count !== 0;
        const remaining = Math.max(0, count - visibleLimit);
        loadMore.hidden = remaining === 0;
        if (remaining > 0) loadMore.textContent = labelFromTemplate(loadMore, Math.min(pageSize, remaining));
        updateOptionCounts();
        updateChips();
        if (updateUrl) syncUrl();
      };

      const readUrl = () => {
        const params = new URLSearchParams(window.location.search);
        allFacets.forEach((facet) => {
          const requestedValue = params.get(`dap_${facet}`);
          inputs.filter((input) => input.name === facet).forEach((input) => { input.checked = input.value === requestedValue; });
        });
        let requestedSort = params.get('dap_sort');
        if (!requestedSort && params.get('sort_by') === 'created-descending') requestedSort = 'newest';
        if (requestedSort && [...sort.options].some((option) => option.value === requestedSort)) sort.value = requestedSort;
      };

      const loadPageChain = async (startUrl, direction) => {
        const loadedCards = [];
        const visited = new Set();
        let pageUrl = startUrl;
        while (pageUrl && !visited.has(pageUrl)) {
          visited.add(pageUrl);
          const response = await fetch(pageUrl, { headers: { Accept: 'text/html' } });
          if (!response.ok) break;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const pageSection = page.querySelector(`[data-dap-collection-discovery][data-section-id="${section.dataset.sectionId}"]`);
          const pageGrid = pageSection?.querySelector('[data-dap-results-grid]');
          if (!pageGrid) break;
          loadedCards.push(...pageGrid.querySelectorAll('[data-dap-filter-item]'));
          pageUrl = pageGrid.dataset[direction] || '';
        }
        return loadedCards;
      };

      const loadRemainingPages = async () => {
        const previousUrl = grid.dataset.previousUrl;
        const nextUrl = grid.dataset.nextUrl;
        if (!previousUrl && !nextUrl) return;
        section.setAttribute('aria-busy', 'true');
        try {
          const pageCards = (await Promise.all([
            loadPageChain(previousUrl, 'previousUrl'),
            loadPageChain(nextUrl, 'nextUrl')
          ])).flat();
          const productIds = new Set(cards.map((card) => card.dataset.productId));
          pageCards.forEach((card) => {
            if (productIds.has(card.dataset.productId)) return;
            productIds.add(card.dataset.productId);
            grid.append(card);
          });
          registerCards();
          render(false);
          section.dispatchEvent(new CustomEvent('dap:collection:updated', { bubbles: true }));
          section.dataset.dapPaginationState = 'complete';
        } catch (error) {
          section.dataset.dapPaginationState = 'error';
        } finally {
          section.removeAttribute('aria-busy');
        }
      };

      const syncShell = () => {
        deactivateFilterDialog(false);
        if (compactFilters.matches) shell.removeAttribute('open');
        else shell.setAttribute('open', '');
      };

      form.addEventListener('change', (event) => {
        const changedInput = event.target;
        if (changedInput.matches?.('input[type="checkbox"]') && changedInput.checked) {
          inputs.filter((input) => input !== changedInput && input.name === changedInput.name).forEach((input) => { input.checked = false; });
        }
        visibleLimit = pageSize;
        render();
      });
      sort.addEventListener('change', () => {
        visibleLimit = pageSize;
        render();
      });
      section.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-dap-remove-filter]');
        if (remove) {
          const input = inputs.find((candidate) => candidate.name === remove.dataset.dapRemoveFilter && candidate.value === remove.dataset.value);
          if (input) input.checked = false;
          visibleLimit = pageSize;
          render();
          return;
        }
        if (event.target.closest('[data-dap-clear-all]')) {
          inputs.forEach((input) => { input.checked = false; });
          visibleLimit = pageSize;
          render();
          return;
        }
        if (event.target.closest('[data-dap-filter-close], [data-dap-filter-show]')) {
          closeFilterDialog(true);
          return;
        }
        if (event.target.closest('[data-dap-load-more]')) {
          visibleLimit += pageSize;
          render(false);
        }
      });
      shell.addEventListener('toggle', () => {
        if (compactFilters.matches && shell.open) activateFilterDialog();
        else deactivateFilterDialog(false);
      });
      section.addEventListener('keydown', (event) => {
        if (!compactFilters.matches || !shell.open) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeFilterDialog(true);
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = filterFocusable();
        if (focusable.length === 0) {
          event.preventDefault();
          filterDialog.focus();
          return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      section.addEventListener('dap:filter-breakpoint-change', syncShell);

      registerCards();
      readUrl();
      syncShell();
      render();
      loadRemainingPages();
    };

    document.querySelectorAll('[data-dap-collection-discovery]').forEach(initDiscovery);
    compactFilters.addEventListener?.('change', () => document.querySelectorAll('[data-dap-collection-discovery]').forEach((section) => {
      section.dispatchEvent(new CustomEvent('dap:filter-breakpoint-change'));
    }));
    document.addEventListener('shopify:section:load', (event) => initDiscovery(event.target.querySelector('[data-dap-collection-discovery]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  (() => {
    const compactFilters = window.matchMedia('(max-width: 1100px)');
    let filterRequest = null;

    const syncFilters = (scope = document, keepCompactOpen = false) => {
      scope.querySelectorAll('.dap-filter-shell').forEach((shell) => {
        const facets = shell.querySelectorAll('.dap-filters form > details');
        if (compactFilters.matches) {
          if (keepCompactOpen) shell.setAttribute('open', '');
          else shell.removeAttribute('open');
          facets.forEach((facet) => {
            if (facet.dataset.filterActive !== 'true') facet.removeAttribute('open');
          });
        } else {
          shell.setAttribute('open', '');
          facets.forEach((facet, index) => facet.toggleAttribute('open', facet.dataset.filterActive === 'true' || index === 0));
        }
      });
      document.body.classList.toggle('dap-filter-open', compactFilters.matches && Boolean(document.querySelector('.dap-filter-shell[open]')));
    };

    const updateCollection = async (url, keepCompactOpen = false, pushState = true) => {
      const currentSection = document.querySelector('[data-dap-collection-section]');
      if (!currentSection) {
        window.location.assign(url.href);
        return;
      }

      filterRequest?.abort();
      filterRequest = new AbortController();
      currentSection.classList.add('is-loading');
      currentSection.setAttribute('aria-busy', 'true');

      const requestUrl = new URL(url.href);
      requestUrl.searchParams.set('section_id', currentSection.dataset.sectionId);
      try {
        const response = await fetch(requestUrl, { signal: filterRequest.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Filter request failed: ${response.status}`);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextSection = parsed.querySelector('[data-dap-collection-section]');
        if (!nextSection) throw new Error('Updated gallery section was not returned.');

        currentSection.replaceWith(nextSection);
        syncFilters(nextSection, keepCompactOpen);
        if (pushState) history.pushState({}, '', `${url.pathname}${url.search}${url.hash}`);
        nextSection.dispatchEvent(new CustomEvent('dap:collection:updated', { bubbles: true }));
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(url.href);
      }
    };

    const formUrl = (form) => {
      const url = new URL(form.action, window.location.origin);
      url.search = new URLSearchParams(new FormData(form)).toString();
      return url;
    };

    syncFilters();
    compactFilters.addEventListener?.('change', () => syncFilters());
    document.addEventListener('shopify:section:load', (event) => syncFilters(event.target));

    document.addEventListener('toggle', (event) => {
      if (!event.target.matches?.('.dap-filter-shell')) return;
      document.body.classList.toggle('dap-filter-open', compactFilters.matches && event.target.open);
    }, true);

    document.addEventListener('click', (event) => {
      const close = event.target.closest('[data-dap-filter-close]');
      if (close) {
        close.closest('.dap-filter-shell')?.removeAttribute('open');
        document.body.classList.remove('dap-filter-open');
        return;
      }

      const filterLink = event.target.closest('.dap-active-filters a, .dap-filter-heading > a, .dap-filter-clear');
      if (!filterLink?.closest('[data-dap-collection-section]')) return;
      event.preventDefault();
      updateCollection(new URL(filterLink.href), Boolean(filterLink.closest('.dap-filter-shell[open]')));
    });

    document.addEventListener('change', (event) => {
      const form = event.target.closest('[data-dap-facets-form], [data-dap-sort-form]');
      if (!form) return;
      const isFacetForm = form.matches('[data-dap-facets-form]');
      updateCollection(formUrl(form), isFacetForm && Boolean(form.closest('.dap-filter-shell[open]')));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-dap-facets-form], [data-dap-sort-form]');
      if (!form) return;
      event.preventDefault();
      updateCollection(formUrl(form), Boolean(form.closest('.dap-filter-shell[open]')));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openShell = document.querySelector('.dap-filter-shell[open]');
      if (!compactFilters.matches || !openShell) return;
      openShell.removeAttribute('open');
      document.body.classList.remove('dap-filter-open');
      openShell.querySelector('summary')?.focus();
    });

    window.addEventListener('popstate', () => updateCollection(new URL(window.location.href), false, false));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const normalizeMediaKey = (value) => {
      const normalized = String(value || '').toLowerCase();
      if (normalized.includes('light oak') || normalized.includes('oak')) return 'light-oak';
      if (normalized.includes('frameless')) return 'frameless';
      if (normalized.includes('black')) return 'black';
      if (normalized.includes('white')) return 'white';
      return 'artwork';
    };

    const initializeProduct = (root) => {
      if (root.dataset.productBound === 'true') return;
      root.dataset.productBound = 'true';

      const variantsNode = root.querySelector('[data-product-variants]');
      if (!variantsNode) return;
      const variants = JSON.parse(variantsNode.textContent);
      const groups = [...root.querySelectorAll('[data-option-group]')];
      const mediaItems = [...root.querySelectorAll('[data-product-media]')];
      const mediaTabs = [...root.querySelectorAll('[data-media-tab]')];
      const variantInput = root.querySelector('[data-product-variant-id]');
      const price = root.querySelector('[data-product-price]');
      const priceOptions = root.querySelector('[data-product-price-options]');
      const selection = root.querySelector('[data-product-selection]');
      const includes = root.querySelector('[data-product-includes]');
      const addButton = root.querySelector('[data-product-add]');
      const addText = root.querySelector('[data-product-add-text]');
      const mediaStatus = root.querySelector('[data-media-status]');
      const quantity = root.querySelector('[data-product-quantity]');
      const sticky = root.querySelector('[data-product-sticky]');
      const stickySelection = root.querySelector('[data-sticky-selection]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      const stickyAddText = root.querySelector('[data-sticky-add-text]');
      const stagePrice = root.querySelector('[data-product-stage-price]');
      let selected;
      try {
        selected = JSON.parse(root.dataset.selectedOptions || '[]');
      } catch {
        selected = [];
      }
      if (!Array.isArray(selected) || selected.length === 0) {
        selected = variants[0]?.options.map(() => '') || [];
      }
      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        const pressed = group.querySelector('[data-option-value][aria-pressed="true"]');
        if (pressed) selected[index] = pressed.dataset.optionValue;
      });
      const finishGroup = groups.find((group) => group.hasAttribute('data-finish-group'));
      const sizeGroup = groups.find((group) => group.hasAttribute('data-size-group'));
      const finishIndex = finishGroup ? Number(finishGroup.dataset.optionIndex) : selected.length - 1;
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: root.dataset.currency || 'USD' });

      const setActiveMedia = (media) => {
        if (!media) return;
        mediaItems.forEach((item) => {
          const active = item === media;
          if (!active) {
            const livingArt = item.querySelector('[data-dap-living-art]');
            if (livingArt) livingArt.dispatchEvent(new CustomEvent('dap:living-art:reset', { bubbles: true }));
          }
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-hidden', String(!active));
          item.toggleAttribute('inert', !active);
        });
        mediaTabs.forEach((tab) => {
          const active = tab.dataset.mediaTarget === media.id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.setAttribute('tabindex', active ? '0' : '-1');
        });
        if (mediaStatus) {
          const template = mediaStatus.dataset.statusTemplate;
          mediaStatus.textContent = template
            .replace('[label]', media.dataset.mediaLabel)
            .replace('[index]', media.dataset.mediaIndex)
            .replace('[count]', String(mediaItems.length));
        }
      };

      const setMediaForFinish = (finish) => {
        const key = normalizeMediaKey(finish);
        const match = mediaItems.find((item) => item.dataset.mediaKey === key)
          || mediaItems.find((item) => item.dataset.mediaKey === 'artwork');
        if (match) setActiveMedia(match);
      };

      const findVariant = (options) => variants.find((variant) => variant.options.every((option, index) => option === options[index]));

      const updateOptionAvailability = () => {
        groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => {
            const candidate = [...selected];
            candidate[index] = button.dataset.optionValue;
            const available = variants.some((variant) => variant.available && variant.options.every((option, optionIndex) => {
              if (optionIndex === index) return option === candidate[optionIndex];
              if (group === sizeGroup && optionIndex === finishIndex) return true;
              return option === selected[optionIndex];
            }));
            button.disabled = !available;
          });
        });
      };

      const updateFinishPrices = () => {
        if (!finishGroup) return;
        const baseOptions = [...selected];
        const baseButton = [...finishGroup.querySelectorAll('[data-option-value]')].find((button) => normalizeMediaKey(button.dataset.optionValue) === 'frameless');
        let baseVariant = null;
        if (baseButton) {
          baseOptions[finishIndex] = baseButton.dataset.optionValue;
          baseVariant = findVariant(baseOptions);
        }
        finishGroup.querySelectorAll('[data-option-value]').forEach((button) => {
          const label = button.querySelector('[data-option-price]');
          if (!label) return;
          const candidate = [...selected];
          candidate[finishIndex] = button.dataset.optionValue;
          const variant = findVariant(candidate);
          if (!variant) {
            label.textContent = '';
            return;
          }
          if (normalizeMediaKey(button.dataset.optionValue) === 'frameless') {
            label.textContent = variant.formattedPrice;
            return;
          }
          const delta = baseVariant ? Math.max(variant.price - baseVariant.price, 0) : 0;
          label.textContent = delta > 0 ? `+${formatter.format(delta / 100)}` : variant.formattedPrice;
        });
      };

      const updateVariant = ({ updateMedia = true } = {}) => {
        groups.forEach((group) => {
          const index = Number(group.dataset.optionIndex);
          group.querySelectorAll('[data-option-value]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.optionValue === selected[index])));
          const current = group.querySelector('[data-option-current]');
          if (current) current.textContent = selected[index];
        });

        const variant = findVariant(selected);
        updateOptionAvailability();
        updateFinishPrices();
        if (!variant) return;

        root.classList.add('is-variant-changing');
        window.setTimeout(() => root.classList.remove('is-variant-changing'), 220);
        variantInput.value = variant.id;
        price.textContent = variant.formattedPrice;
        if (stagePrice) stagePrice.textContent = variant.formattedPrice;
        const optionsText = variant.options.join(' · ');
        if (priceOptions) priceOptions.textContent = optionsText;
        selection.textContent = selection.dataset.selectionTemplate.replace('[options]', optionsText).replace('[price]', variant.formattedPrice);
        const finish = selected[finishIndex] || '';
        includes.textContent = normalizeMediaKey(finish) === 'frameless' ? includes.dataset.framelessLabel : includes.dataset.framedLabel;
        addButton.disabled = !variant.available;
        addText.textContent = variant.available ? addButton.dataset.addTemplate.replace('[price]', variant.formattedPrice) : addButton.dataset.soldOutLabel;
        if (stickySelection) stickySelection.textContent = optionsText;
        if (stickyAdd) stickyAdd.disabled = !variant.available;
        if (stickyAddText && stickyAdd) stickyAddText.textContent = variant.available ? stickyAdd.dataset.addTemplate.replace('[price]', variant.formattedPrice) : stickyAdd.dataset.soldOutLabel;
        if (updateMedia) setMediaForFinish(finish);

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      groups.forEach((group) => {
        const index = Number(group.dataset.optionIndex);
        group.querySelectorAll('[data-option-value]').forEach((button) => {
          button.addEventListener('click', () => {
            if (button.disabled) return;
            const previousFinish = selected[finishIndex];
            selected[index] = button.dataset.optionValue;
            if (group === sizeGroup && !findVariant(selected)) {
              const matchingVariant = variants.find((variant) => variant.available
                && variant.options[index] === selected[index]
                && normalizeMediaKey(variant.options[finishIndex]) === 'frameless'
                && variant.options.every((option, optionIndex) => optionIndex === index || optionIndex === finishIndex || option === selected[optionIndex]));
              if (matchingVariant) selected[finishIndex] = matchingVariant.options[finishIndex];
            }
            updateVariant({ updateMedia: index === finishIndex || selected[finishIndex] !== previousFinish });
          });
        });
      });

      mediaTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => setActiveMedia(mediaItems.find((item) => item.id === tab.dataset.mediaTarget)));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = mediaTabs.length - 1;
          if (event.key === 'ArrowRight') next = (index + 1) % mediaTabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + mediaTabs.length) % mediaTabs.length;
          mediaTabs[next].focus();
          mediaTabs[next].click();
        });
      });

      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const next = Math.max(1, Number(quantity.value || 1) + Number(button.dataset.quantityChange));
          quantity.value = String(next);
        });
      });

      if (sticky) {
        const compactPurchase = window.matchMedia('(max-width: 600px)');
        const productHeading = root.querySelector('.dap-product-info h1');
        const syncSticky = () => {
          const rootRect = root.getBoundingClientRect();
          const addRect = addButton.getBoundingClientRect();
          const headingRect = productHeading ? productHeading.getBoundingClientRect() : null;
          const rootVisible = rootRect.top < window.innerHeight && rootRect.bottom > 0;
          const primaryAddVisible = addRect.top < window.innerHeight && addRect.bottom > 0;
          const hasScrolledPastProductStart = rootRect.top <= -16;
          const headingClearsStickyBar = !headingRect || headingRect.bottom <= window.innerHeight - 104;
          sticky.hidden = !compactPurchase.matches || !rootVisible || primaryAddVisible || !hasScrolledPastProductStart || !headingClearsStickyBar;
        };
        const stickyObserver = new IntersectionObserver(syncSticky, { threshold: [0, 1] });
        stickyObserver.observe(root);
        stickyObserver.observe(addButton);
        compactPurchase.addEventListener?.('change', syncSticky);
        window.addEventListener('scroll', syncSticky, { passive: true });
        syncSticky();
      }

      updateVariant({ updateMedia: true });
    };

    document.querySelectorAll('[data-dap-product-root]').forEach(initializeProduct);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-dap-product-root]').forEach(initializeProduct));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  (() => {
    const root = document.documentElement;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const header = document.querySelector('[data-dap-header]');
    const progress = document.querySelector('[data-dap-progress]');
    const mobileMenus = [...document.querySelectorAll('.dap-mobile-menu')];
    let ticking = false;

    mobileMenus.forEach((menu) => {
      const summary = menu.querySelector('summary');
      const panel = menu.querySelector('.dap-mobile-panel');
      if (!summary || !panel) return;
      const isolationTargets = [
        document.querySelector('main'),
        document.querySelector('footer'),
        document.querySelector('.dap-wordmark'),
        ...document.querySelectorAll('.dap-nav-tools > a'),
      ].filter(Boolean);

      const setPageIsolation = (isolated) => {
        isolationTargets.forEach((target) => {
          if (isolated) {
            if (!target.hasAttribute('inert')) {
              target.setAttribute('inert', '');
              target.dataset.dapMenuIsolated = 'true';
            }
          } else if (target.dataset.dapMenuIsolated === 'true') {
            target.removeAttribute('inert');
            delete target.dataset.dapMenuIsolated;
          }
        });
      };

      const syncMenuState = () => {
        summary.setAttribute('aria-expanded', String(menu.open));
        summary.setAttribute('aria-label', menu.open ? summary.dataset.closeLabel : summary.dataset.openLabel);
        setPageIsolation(menu.open);
      };

      menu.addEventListener('keydown', (event) => {
        if (!menu.open || event.key !== 'Tab') return;
        const focusable = [summary, ...panel.querySelectorAll('a[href]')]
          .filter((element) => !element.hasAttribute('disabled') && element.getClientRects().length > 0);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      menu.addEventListener('toggle', syncMenuState);
      window.addEventListener('resize', () => {
        if (window.innerWidth > 800 && menu.open) menu.open = false;
      }, { passive: true });
      syncMenuState();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      mobileMenus.forEach((menu) => {
        if (!menu.open) return;
        menu.open = false;
        menu.querySelector('summary')?.focus();
      });
    });

    const updateScroll = () => {
      const distance = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      const ratio = Math.min(window.scrollY / distance, 1);
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 24);
      if (progress) progress.style.transform = `scaleX(${ratio})`;
      const hero = document.querySelector('.dap-hero');
      if (hero && !reducedMotion.matches) hero.style.setProperty('--dap-hero-shift', `${Math.min(window.scrollY * .075, 70)}px`);
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScroll);
    };

    const observer = reducedMotion.matches ? null : new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -9% 0px', threshold: .08 });

    const revealIfInViewport = (element) => {
      const box = element.getBoundingClientRect();
      if (box.top >= window.innerHeight * 1.05 || box.bottom <= 0) return false;
      element.classList.add('is-visible');
      observer?.unobserve(element);
      return true;
    };

    const prepareMotion = (scope = document) => {
      root.classList.add('dap-motion-ready');
      const sections = scope.querySelectorAll('main .shopify-section > section, main .shopify-section > article, main .dap-product-card, main [data-dap-reveal]');
      sections.forEach((element, index) => {
        if (element.dataset.dapMotionBound === 'true' || element.classList.contains('dap-hero')) return;
        element.dataset.dapMotionBound = 'true';
        if (!element.hasAttribute('data-dap-reveal')) element.setAttribute('data-dap-reveal', 'rise');
        element.style.setProperty('--dap-reveal-delay', `${Math.min(index % 4, 3) * 70}ms`);
        if (reducedMotion.matches || !observer || revealIfInViewport(element)) element.classList.add('is-visible');
        else observer.observe(element);
      });
      window.requestAnimationFrame(() => sections.forEach((element) => revealIfInViewport(element)));
    };

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-dap-room-toggle]');
      if (!toggle) return;
      event.preventDefault();
      event.stopPropagation();
      const card = toggle.closest('[data-dap-product-card]');
      if (!card) return;
      const livingArt = card.querySelector('[data-dap-living-art]');
      if (livingArt) livingArt.dispatchEvent(new CustomEvent('dap:living-art:reset', { bubbles: true }));
      const roomActive = card.dataset.view !== 'room';
      card.dataset.view = roomActive ? 'room' : 'artwork';
      toggle.setAttribute('aria-pressed', String(roomActive));
      toggle.setAttribute('aria-label', roomActive ? toggle.dataset.artworkAria : toggle.dataset.roomAria);
      const label = toggle.querySelector('[data-dap-view-label]');
      if (label) label.textContent = roomActive ? toggle.dataset.artworkLabel : toggle.dataset.roomLabel;
    });

    document.addEventListener('shopify:section:load', (event) => prepareMotion(event.target));
    window.addEventListener('scroll', onScroll, { passive: true });
    prepareMotion();
    updateScroll();
  })();

  (() => {
      if (window.dapLivingArtBound) return;
      window.dapLivingArtBound = true;
      document.documentElement.dataset.dapLivingArtController = 'intent-hydrated-mobile-autoplay-global-prewarm';

      let activeExperience = null;
      let playRequest = 0;
      const pendingStarts = new WeakMap();
      const playbackStartTimeoutMs = 12000;
      const fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const mobileViewport = window.matchMedia('(max-width: 600px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = window.navigator?.connection || window.navigator?.mozConnection || window.navigator?.webkitConnection;
      const mobileAutoplayStorageKey = 'dap-living-art-mobile-autoplay-v2';
      const mobileAutoplayStorageLimit = 100;

      const readMobileAutoplayKeys = () => {
        try {
          const storedKeys = JSON.parse(window.localStorage.getItem(mobileAutoplayStorageKey) || '[]');
          if (!Array.isArray(storedKeys)) return new Set();
          return new Set(storedKeys.filter((key) => typeof key === 'string').slice(-mobileAutoplayStorageLimit));
        } catch (error) {
          void error;
          return new Set();
        }
      };

      let mobileAutoplaySeenKeys = readMobileAutoplayKeys();

      const mobileAutoplayKeyFor = (experience) => experience?.dataset.livingAutoplayKey || '';
      const mobileAutoplayWasSeen = (experience) => {
        const key = mobileAutoplayKeyFor(experience);
        return !key || mobileAutoplaySeenKeys.has(key);
      };

      const rememberMobileAutoplay = (experience) => {
        const key = mobileAutoplayKeyFor(experience);
        if (!key) return;
        mobileAutoplaySeenKeys.delete(key);
        mobileAutoplaySeenKeys.add(key);
        mobileAutoplaySeenKeys = new Set([...mobileAutoplaySeenKeys].slice(-mobileAutoplayStorageLimit));
        try {
          window.localStorage.setItem(mobileAutoplayStorageKey, JSON.stringify([...mobileAutoplaySeenKeys]));
        } catch (error) {
          void error;
        }
      };

      const registrationIsStable = (experience) => {
        const media = experience?.closest('.dap-product-media');
        if (!media) return true;
        const style = window.getComputedStyle(media);
        return style.transform === 'none' && style.clipPath === 'none';
      };

      const allowsAutomaticPlayback = () => {
        const slowConnection = ['slow-2g', '2g'].includes(connection?.effectiveType);
        return !reducedMotion.matches && !connection?.saveData && !slowConnection;
      };

      const allowsHoverPlayback = () => fineHover.matches && allowsAutomaticPlayback();
      const allowsMobileAutoplay = () => mobileViewport.matches && allowsAutomaticPlayback();

      const hydrateExperience = (experience) => {
        if (!experience) return null;
        let video = experience.querySelector('.dap-living-art-video');
        if (video) return video;

        const media = experience.querySelector('[data-living-media]');
        const videoTemplate = experience.querySelector('[data-living-video-template]');
        if (!media || !videoTemplate) return null;

        media.append(videoTemplate.content.cloneNode(true));
        videoTemplate.remove();
        const interfaceTemplate = experience.querySelector('[data-living-interface-template]');
        if (interfaceTemplate) {
          experience.append(interfaceTemplate.content.cloneNode(true));
          interfaceTemplate.remove();
        }

        video = experience.querySelector('.dap-living-art-video');
        if (!video) return null;
        video.muted = true;
        experience.dataset.livingHydrated = 'true';
        return video;
      };

      const cancelPendingStart = (experience) => {
        const pending = pendingStarts.get(experience);
        if (!pending) return;
        pending.cancel();
        pendingStarts.delete(experience);
      };

      const setControl = (experience, labelKey, ariaKey) => {
        const control = experience?.querySelector('[data-living-control]');
        const label = experience?.querySelector('[data-living-label]');
        if (!control || !label) return;
        label.textContent = control.dataset[labelKey] || '';
        control.setAttribute('aria-label', control.dataset[ariaKey] || label.textContent);
      };

      const setStatus = (experience, statusKey) => {
        const status = experience?.querySelector('[data-living-status]');
        if (status) status.textContent = status.dataset[statusKey] || '';
      };

      const resetExperience = (experience, { rearm = false } = {}) => {
        if (!experience) return;
        const video = experience.querySelector('.dap-living-art-video');
        experience.dataset.livingRequest = String(++playRequest);
        cancelPendingStart(experience);
        if (video) {
          video.pause();
          try { video.currentTime = 0; } catch (error) { void error; }
        }
        experience.dataset.livingState = 'idle';
        delete experience.dataset.livingAutomaticMode;
        if (rearm) experience.dataset.livingHoverArmed = 'true';
        if (experience.dataset.livingPlayed === 'true') {
          setControl(experience, 'replayLabel', 'replayAria');
        } else {
          setControl(experience, 'playLabel', 'playAria');
        }
        if (activeExperience === experience) activeExperience = null;
      };

      const finishExperience = (experience, { rearm = false } = {}) => {
        if (!experience) return;
        const video = experience.querySelector('.dap-living-art-video');
        experience.dataset.livingRequest = String(++playRequest);
        cancelPendingStart(experience);
        if (video) {
          video.pause();
          try { video.currentTime = 0; } catch (error) { void error; }
        }
        experience.dataset.livingState = 'complete';
        setControl(experience, 'replayLabel', 'replayAria');
        setStatus(experience, 'completeStatus');
        if (activeExperience === experience) activeExperience = null;
        window.setTimeout(() => {
          if (experience.dataset.livingState === 'complete') {
            resetExperience(experience, { rearm });
          }
        }, 340);
      };

      const stopActiveExperience = (nextExperience) => {
        if (!activeExperience || activeExperience === nextExperience) return;
        finishExperience(activeExperience, { rearm: true });
      };

      const startExperience = async (experience, { automatic = false, mobileAutomatic = false } = {}) => {
        const video = hydrateExperience(experience);
        if (!experience || !video) return false;
        if (!registrationIsStable(experience)) return false;
        if (automatic && !allowsHoverPlayback()) return false;
        if (mobileAutomatic && !allowsMobileAutoplay()) return false;
        if (mobileAutomatic && mobileAutoplayWasSeen(experience)) return false;
        const pendingStart = pendingStarts.get(experience);
        if (pendingStart) {
          if (!automatic && !mobileAutomatic) experience.dataset.livingAutomaticMode = 'manual';
          return pendingStart.promise;
        }
        if (experience.dataset.livingState === 'playing') return false;

        stopActiveExperience(experience);
        activeExperience = experience;
        experience.dataset.livingPlayed = 'true';
        experience.dataset.livingAutomaticMode = automatic ? 'hover' : mobileAutomatic ? 'mobile' : 'manual';

        if (experience.dataset.livingState === 'complete' || (video.duration && video.currentTime >= video.duration - .05)) {
          try { video.currentTime = 0; } catch (error) { void error; }
        }

        video.muted = true;
        experience.dataset.livingState = 'loading';
        setControl(experience, 'loadingLabel', 'loadingAria');
        const request = String(++playRequest);
        experience.dataset.livingRequest = request;

        let rejectStartGuard;
        let startTimeout;
        const startGuard = new Promise((resolve, reject) => {
          void resolve;
          rejectStartGuard = reject;
          startTimeout = window.setTimeout(() => {
            reject(new Error('DAP_PLAYBACK_START_TIMEOUT'));
          }, playbackStartTimeoutMs);
        });
        const pending = {
          cancel: () => rejectStartGuard?.(new Error('DAP_PLAYBACK_START_CANCELLED')),
          promise: null,
        };

        pending.promise = (async () => {
          try {
            await Promise.race([video.play(), startGuard]);
            if (experience.dataset.livingRequest !== request) {
              video.pause();
              return false;
            }
            if (video.paused || video.readyState < 2) {
              throw new Error('DAP_PLAYBACK_DID_NOT_START');
            }
            delete experience.dataset.livingErrorReason;
            experience.dataset.livingState = 'playing';
            setControl(experience, 'pauseLabel', 'pauseAria');
            setStatus(experience, 'playingStatus');
            if (mobileAutomatic) rememberMobileAutoplay(experience);
            return true;
          } catch (error) {
            if (experience.dataset.livingRequest !== request) return false;
            video.pause();
            try { video.load(); } catch (loadError) { void loadError; }
            experience.dataset.livingErrorReason = error?.message || 'DAP_PLAYBACK_START_FAILED';
            experience.dataset.livingState = 'error';
            setControl(experience, 'replayLabel', 'replayAria');
            setStatus(experience, 'errorStatus');
            if (activeExperience === experience) activeExperience = null;
            return false;
          } finally {
            window.clearTimeout(startTimeout);
            if (pendingStarts.get(experience) === pending) pendingStarts.delete(experience);
          }
        })();
        pendingStarts.set(experience, pending);
        return pending.promise;
      };

      const prewarmExperience = (experience) => {
        if (!experience || experience.dataset.livingPrewarmed === 'true') return null;
        const video = hydrateExperience(experience);
        if (!video) return null;

        const playbackIsUnderway = pendingStarts.has(experience)
          || ['loading', 'playing', 'paused'].includes(experience.dataset.livingState)
          || video.readyState >= 2;
        if (!playbackIsUnderway) {
          video.preload = 'auto';
          try { video.load(); } catch (error) { void error; }
        }
        experience.dataset.livingPrewarmed = 'true';
        return video;
      };

      const prewarmFeatureExperiences = (scope = document) => {
        if (!allowsAutomaticPlayback()) return;
        scope.querySelectorAll('[data-dap-living-art][data-living-context="feature"]').forEach(prewarmExperience);
      };

      document.addEventListener('pointerdown', (event) => {
        const control = event.target.closest('[data-living-control]');
        if (control) prewarmExperience(control.closest('[data-dap-living-art]'));
      }, { passive: true });

      document.addEventListener('focusin', (event) => {
        const control = event.target.closest('[data-living-control]');
        if (control) prewarmExperience(control.closest('[data-dap-living-art]'));
      });

      const hoverHostForTarget = (target) => target?.closest?.('.dap-product-card-media, .dap-product-media');

      document.addEventListener('pointerover', (event) => {
        if (!allowsHoverPlayback()) return;
        const host = hoverHostForTarget(event.target);
        if (!host || (event.relatedTarget && host.contains(event.relatedTarget))) return;
        const experience = host.querySelector('[data-dap-living-art]');
        if (!experience || experience.dataset.livingHoverArmed === 'false') return;
        const card = host.closest('[data-dap-product-card]');
        if (card?.dataset.view === 'room') return;
        if (host.matches('[data-product-media]') && !host.classList.contains('is-active')) return;
        experience.dataset.livingHoverArmed = 'false';
        startExperience(experience, { automatic: true });
      });

      document.addEventListener('pointerout', (event) => {
        if (!fineHover.matches) return;
        const host = hoverHostForTarget(event.target);
        if (!host || (event.relatedTarget && host.contains(event.relatedTarget))) return;
        const experience = host.querySelector('[data-dap-living-art]');
        if (!experience) return;
        experience.dataset.livingHoverArmed = 'true';
        if (['loading', 'playing', 'paused'].includes(experience.dataset.livingState)) {
          finishExperience(experience, { rearm: true });
        }
      });

      document.addEventListener('click', (event) => {
        const control = event.target.closest('[data-living-control]');
        if (!control) return;
        event.preventDefault();
        event.stopPropagation();

        const experience = control.closest('[data-dap-living-art]');
        if (!experience) return;
        const video = experience.querySelector('.dap-living-art-video');

        if (experience.dataset.livingState === 'playing' && video) {
          video.pause();
          experience.dataset.livingState = 'paused';
          setControl(experience, 'resumeLabel', 'resumeAria');
          setStatus(experience, 'pausedStatus');
          return;
        }

        startExperience(experience);
      });

      document.addEventListener('ended', (event) => {
        const video = event.target.closest?.('[data-dap-living-art] video');
        if (!video) return;
        finishExperience(video.closest('[data-dap-living-art]'));
      }, true);

      document.addEventListener('dap:living-art:reset', (event) => {
        resetExperience(event.target.closest('[data-dap-living-art]'), { rearm: true });
      });

      let mobileAutoplayObserver = null;
      let mobileAutoplayPending = false;

      const initializeMobileAutoplay = (scope = document) => {
        if (!allowsMobileAutoplay()) return;

        const experiences = [...scope.querySelectorAll('[data-dap-living-art]')];
        if (!experiences.length) return;

        if (!mobileAutoplayObserver) {
          mobileAutoplayObserver = new IntersectionObserver(async (entries, observer) => {
            const nearbyEntries = entries
              .filter((entry) => entry.isIntersecting && entry.intersectionRatio >= .35)
              .sort((first, second) => second.intersectionRatio - first.intersectionRatio);

            const seenEntryToPrewarm = nearbyEntries.find((entry) => mobileAutoplayWasSeen(entry.target));
            if (seenEntryToPrewarm) {
              prewarmExperience(seenEntryToPrewarm.target);
              observer.unobserve(seenEntryToPrewarm.target);
            }

            if (mobileAutoplayPending) return;

            const visibleEntries = nearbyEntries.filter((entry) => entry.intersectionRatio >= .65);

            for (const visibleEntry of visibleEntries) {
              const experience = visibleEntry.target;
              if (mobileAutoplayWasSeen(experience)) continue;

              const card = experience.closest('[data-dap-product-card]');
              const media = experience.closest('[data-product-media]');
              if (card?.dataset.view === 'room') continue;
              if (media && !media.classList.contains('is-active')) continue;

              mobileAutoplayPending = true;
              const started = await startExperience(experience, { mobileAutomatic: true });
              mobileAutoplayPending = false;
              if (started) observer.unobserve(experience);
              break;
            }
          }, {
            threshold: [.35, .65],
            rootMargin: '0px 0px -8% 0px'
          });
        }

        experiences.forEach((experience) => {
          const alreadyPrepared = experience.dataset.livingPrewarmed === 'true' && mobileAutoplayWasSeen(experience);
          if (!alreadyPrepared) mobileAutoplayObserver.observe(experience);
        });
      };

      const respectPlaybackPreference = () => {
        if (!activeExperience) return;
        const mode = activeExperience.dataset.livingAutomaticMode;
        if (mode === 'hover' && !allowsHoverPlayback()) finishExperience(activeExperience, { rearm: true });
        if (mode === 'mobile' && !allowsMobileAutoplay()) finishExperience(activeExperience);
      };

      fineHover.addEventListener?.('change', respectPlaybackPreference);
      mobileViewport.addEventListener?.('change', respectPlaybackPreference);
      reducedMotion.addEventListener?.('change', respectPlaybackPreference);
      connection?.addEventListener?.('change', respectPlaybackPreference);
      document.addEventListener('shopify:section:load', (event) => {
        prewarmFeatureExperiences(event.target);
        initializeMobileAutoplay(event.target);
      });
      document.addEventListener('dap:collection:updated', (event) => {
        prewarmFeatureExperiences(event.target);
        initializeMobileAutoplay(event.target);
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          prewarmFeatureExperiences();
          initializeMobileAutoplay();
        }, { once: true });
      } else {
        prewarmFeatureExperiences();
        initializeMobileAutoplay();
      }
      document.documentElement.dataset.dapLivingArtReady = 'true';
    })();

  } catch(e) { console.error(e); }
})();
})();
